import type { IdeaSource } from './types';

/** Ideenbuch 11–20: pan, rice and oven. */
export const IDEAS_2: IdeaSource[] = [
  {
    id: 'chicken-veg-pan',
    minutes: 30,
    tags: ['kids'],
    de: {
      title: 'Hähnchen-Gemüse-Pfanne mit Reis',
      ingredients: [
        '500 g Hähnchenbrust',
        '250 g Reis',
        '2 Paprika',
        '1 Zucchini',
        '2 Möhren',
        '3 EL Sojasoße',
        '1 TL Honig',
        '2 EL Öl',
      ],
      steps: [
        'Reis nach Packung kochen.',
        'Hähnchen in Streifen schneiden und in Öl 6 Minuten scharf anbraten.',
        'Gemüse in Streifen schneiden, dazugeben und 5 Minuten mitbraten.',
        'Sojasoße und Honig unterrühren und mit dem Reis servieren.',
      ],
      kidsTip: 'Gemüse für die Kinder etwas länger braten, dann ist es weicher.',
    },
    en: {
      title: 'Chicken and vegetable stir-fry with rice',
      ingredients: [
        '500 g chicken breast',
        '250 g rice',
        '2 peppers',
        '1 courgette',
        '2 carrots',
        '3 tbsp soy sauce',
        '1 tsp honey',
        '2 tbsp oil',
      ],
      steps: [
        'Cook the rice as the packet says.',
        'Cut the chicken into strips and fry hot in the oil for 6 minutes.',
        'Cut the vegetables into strips, add them and fry for 5 minutes.',
        'Stir in the soy sauce and honey and serve with the rice.',
      ],
      kidsTip: 'Fry the vegetables a bit longer for the kids – softer that way.',
    },
  },
  {
    id: 'fried-rice',
    minutes: 20,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Gebratener Reis mit Gemüse und Ei',
      ingredients: [
        '600 g gekochter Reis (vom Vortag)',
        '3 Eier',
        '200 g TK-Erbsen',
        '2 Möhren, gewürfelt',
        '3 Frühlingszwiebeln',
        '3 EL Sojasoße',
        '2 EL Öl',
      ],
      steps: [
        'Möhren in Öl 3 Minuten anbraten, Erbsen dazugeben.',
        'Den Reis dazugeben und 5 Minuten braten, bis er knusprig wird.',
        'Reis zur Seite schieben, Eier in die Pfanne schlagen und als Rührei stocken lassen.',
        'Alles mischen, mit Sojasoße würzen und mit Frühlingszwiebeln bestreuen.',
      ],
      kidsTip: 'Ideal für Reis von gestern – kalter Reis brät am besten.',
    },
    en: {
      title: 'Egg fried rice with vegetables',
      ingredients: [
        '600 g cooked rice (from the day before)',
        '3 eggs',
        '200 g frozen peas',
        '2 carrots, diced',
        '3 spring onions',
        '3 tbsp soy sauce',
        '2 tbsp oil',
      ],
      steps: [
        'Fry the carrots in the oil for 3 minutes and add the peas.',
        'Add the rice and fry for 5 minutes until it turns crispy.',
        'Push the rice aside, crack the eggs into the pan and scramble them.',
        'Mix everything, season with soy sauce and scatter over the spring onions.',
      ],
      kidsTip: 'Perfect for yesterday’s rice – cold rice fries best.',
    },
  },
  {
    id: 'fish-fingers-mash',
    minutes: 30,
    tags: ['kids'],
    de: {
      title: 'Fischstäbchen mit Kartoffelpüree und Erbsen',
      ingredients: [
        '15 Fischstäbchen',
        '1 kg mehligkochende Kartoffeln',
        '200 ml Milch',
        '2 EL Butter',
        '300 g TK-Erbsen',
        '1 Prise Muskat',
      ],
      steps: [
        'Kartoffeln schälen, würfeln und in Salzwasser 20 Minuten weich kochen.',
        'Fischstäbchen nach Packung im Ofen oder in der Pfanne zubereiten.',
        'Erbsen 4 Minuten in wenig Wasser garen.',
        'Kartoffeln abgießen, mit warmer Milch, Butter und Muskat zu Püree stampfen.',
      ],
      kidsTip: 'Ein Klecks Ketchup macht aus dem Püree einen Vulkan.',
    },
    en: {
      title: 'Fish fingers with mash and peas',
      ingredients: [
        '15 fish fingers',
        '1 kg floury potatoes',
        '200 ml milk',
        '2 tbsp butter',
        '300 g frozen peas',
        '1 pinch nutmeg',
      ],
      steps: [
        'Peel and dice the potatoes and boil in salted water for 20 minutes until soft.',
        'Cook the fish fingers in the oven or pan as the packet says.',
        'Cook the peas in a little water for 4 minutes.',
        'Drain the potatoes and mash with warm milk, butter and nutmeg.',
      ],
      kidsTip: 'A dollop of ketchup turns the mash into a volcano.',
    },
  },
  {
    id: 'baked-potatoes',
    minutes: 60,
    tags: ['veggie'],
    de: {
      title: 'Ofenkartoffeln mit Kräuterquark',
      ingredients: [
        '8 große Kartoffeln',
        '500 g Quark',
        '100 ml Milch',
        '1 Bund Schnittlauch',
        '1 Knoblauchzehe',
        '2 EL Olivenöl',
        '1 Gurke',
      ],
      steps: [
        'Ofen auf 200 °C vorheizen, Kartoffeln waschen, längs halbieren und mit Öl einpinseln.',
        'Mit der Schnittfläche nach unten 45 Minuten backen.',
        'Quark mit Milch glatt rühren, Schnittlauch und Knoblauch unterrühren, salzen.',
        'Gurke in Scheiben schneiden und alles zusammen servieren.',
      ],
      kidsTip: 'Kartoffeln mit Gesichtern einritzen – sie backen lustig mit.',
    },
    en: {
      title: 'Baked potatoes with herb quark',
      ingredients: [
        '8 large potatoes',
        '500 g quark',
        '100 ml milk',
        '1 bunch chives',
        '1 clove garlic',
        '2 tbsp olive oil',
        '1 cucumber',
      ],
      steps: [
        'Heat the oven to 200 °C, wash the potatoes, halve them lengthways and brush with oil.',
        'Bake cut side down for 45 minutes.',
        'Stir the quark smooth with the milk, add the chives and garlic and season with salt.',
        'Slice the cucumber and serve everything together.',
      ],
      kidsTip: 'Score faces into the potatoes – they bake along.',
    },
  },
  {
    id: 'roast-veg-feta',
    minutes: 40,
    tags: ['veggie'],
    de: {
      title: 'Ofengemüse mit Feta',
      ingredients: [
        '800 g Kartoffeln',
        '2 Paprika',
        '1 Zucchini',
        '1 rote Zwiebel',
        '200 g Feta',
        '3 EL Olivenöl',
        '1 TL Paprikapulver',
      ],
      steps: [
        'Ofen auf 200 °C vorheizen.',
        'Kartoffeln vierteln, Gemüse in grobe Stücke schneiden.',
        'Alles mit Öl, Paprikapulver und Salz mischen und auf einem Blech verteilen.',
        '30 Minuten backen.',
        'Feta darüberbröseln und weitere 5 Minuten backen.',
      ],
      kidsTip: 'Feta nur auf eine Hälfte des Blechs.',
    },
    en: {
      title: 'Roast vegetables with feta',
      ingredients: [
        '800 g potatoes',
        '2 peppers',
        '1 courgette',
        '1 red onion',
        '200 g feta',
        '3 tbsp olive oil',
        '1 tsp paprika',
      ],
      steps: [
        'Heat the oven to 200 °C.',
        'Quarter the potatoes and cut the vegetables into chunks.',
        'Mix everything with the oil, paprika and salt and spread on a tray.',
        'Bake for 30 minutes.',
        'Crumble the feta over it and bake for another 5 minutes.',
      ],
      kidsTip: 'Feta on just one half of the tray.',
    },
  },
  {
    id: 'meatballs-potato-salad',
    minutes: 45,
    tags: ['kids'],
    de: {
      title: 'Frikadellen mit Kartoffelsalat',
      ingredients: [
        '500 g gemischtes Hackfleisch',
        '1 Brötchen vom Vortag',
        '1 Ei',
        '1 Zwiebel, fein gewürfelt',
        '1 TL Senf',
        '1 kg festkochende Kartoffeln',
        '200 ml Gemüsebrühe',
        '3 EL Essig',
        '3 EL Öl',
        '1 Gurke',
      ],
      steps: [
        'Kartoffeln mit Schale 20 Minuten kochen, pellen und in Scheiben schneiden.',
        'Warme Brühe mit Essig, Öl, Salz und Pfeffer verrühren, über die Kartoffeln gießen, Gurkenscheiben untermischen und ziehen lassen.',
        'Brötchen einweichen, ausdrücken und mit Hack, Ei, Zwiebel, Senf, Salz und Pfeffer verkneten.',
        'Acht Frikadellen formen und in Öl von jeder Seite 5 Minuten braten.',
      ],
      kidsTip: 'Kleine Frikadellen braten schneller und passen in Kinderhände.',
    },
    en: {
      title: 'German meatballs with potato salad',
      ingredients: [
        '500 g mixed mince',
        '1 stale bread roll',
        '1 egg',
        '1 onion, finely diced',
        '1 tsp mustard',
        '1 kg waxy potatoes',
        '200 ml vegetable stock',
        '3 tbsp vinegar',
        '3 tbsp oil',
        '1 cucumber',
      ],
      steps: [
        'Boil the potatoes in their skins for 20 minutes, peel and slice.',
        'Mix the warm stock with the vinegar, oil, salt and pepper, pour over the potatoes, fold in cucumber slices and let it soak in.',
        'Soak the roll, squeeze it out and knead with the mince, egg, onion, mustard, salt and pepper.',
        'Shape eight patties and fry each side in oil for 5 minutes.',
      ],
      kidsTip: 'Small patties cook faster and fit in kids’ hands.',
    },
  },
  {
    id: 'schnitzel',
    minutes: 40,
    tags: ['kids'],
    de: {
      title: 'Schnitzel mit Bratkartoffeln',
      ingredients: [
        '4 Schweineschnitzel',
        '2 Eier',
        '80 g Semmelbrösel',
        '50 g Mehl',
        '1 kg gekochte Kartoffeln (vom Vortag)',
        '1 Zwiebel, gewürfelt',
        '1 Zitrone',
        '6 EL Öl',
      ],
      steps: [
        'Kartoffeln in Scheiben schneiden und in 3 EL Öl 15 Minuten knusprig braten, Zwiebel die letzten 5 Minuten mitbraten.',
        'Schnitzel dünn klopfen, salzen und nacheinander in Mehl, verquirltem Ei und Bröseln wenden.',
        'Im restlichen Öl von jeder Seite 3 Minuten goldbraun braten.',
        'Mit Zitronenspalten und den Bratkartoffeln servieren.',
      ],
      kidsTip: 'Kinder helfen gern beim Panieren – Schürze nicht vergessen.',
    },
    en: {
      title: 'Schnitzel with fried potatoes',
      ingredients: [
        '4 pork escalopes',
        '2 eggs',
        '80 g breadcrumbs',
        '50 g flour',
        '1 kg cooked potatoes (from the day before)',
        '1 onion, diced',
        '1 lemon',
        '6 tbsp oil',
      ],
      steps: [
        'Slice the potatoes and fry in 3 tbsp oil for 15 minutes until crisp, adding the onion for the last 5 minutes.',
        'Beat the escalopes thin, salt them and coat in flour, beaten egg and breadcrumbs.',
        'Fry in the rest of the oil for 3 minutes on each side until golden.',
        'Serve with lemon wedges and the fried potatoes.',
      ],
      kidsTip: 'Kids love helping with the breadcrumbs – aprons on.',
    },
  },
  {
    id: 'chicken-legs-potatoes',
    minutes: 60,
    tags: ['kids'],
    de: {
      title: 'Hähnchenschenkel mit Ofenkartoffeln',
      ingredients: [
        '4 Hähnchenschenkel',
        '1 kg kleine Kartoffeln',
        '2 EL Olivenöl',
        '2 TL Paprikapulver',
        '1 TL Rosmarin',
        '1 Knoblauchzehe',
      ],
      steps: [
        'Ofen auf 200 °C vorheizen.',
        'Öl mit Paprikapulver, Rosmarin, gepresstem Knoblauch und Salz verrühren.',
        'Hähnchenschenkel und halbierte Kartoffeln damit einreiben und auf ein Blech legen.',
        '45 Minuten backen, bis die Haut knusprig ist.',
      ],
      kidsTip: 'Einen Joghurt-Dip dazu stellen.',
    },
    en: {
      title: 'Chicken legs with roast potatoes',
      ingredients: [
        '4 chicken legs',
        '1 kg small potatoes',
        '2 tbsp olive oil',
        '2 tsp paprika',
        '1 tsp rosemary',
        '1 clove garlic',
      ],
      steps: [
        'Heat the oven to 200 °C.',
        'Mix the oil with the paprika, rosemary, crushed garlic and salt.',
        'Rub the chicken legs and halved potatoes with it and lay them on a tray.',
        'Bake for 45 minutes until the skin is crisp.',
      ],
      kidsTip: 'Add a yoghurt dip on the side.',
    },
  },
  {
    id: 'goulash-noodles',
    minutes: 100,
    tags: [],
    de: {
      title: 'Gulasch mit Nudeln',
      ingredients: [
        '800 g Rindergulasch',
        '3 Zwiebeln, gewürfelt',
        '2 EL Tomatenmark',
        '2 EL Paprikapulver edelsüß',
        '500 ml Rinderbrühe',
        '1 Paprika',
        '400 g Bandnudeln',
        '2 EL Öl',
      ],
      steps: [
        'Fleisch in Öl portionsweise kräftig anbraten.',
        'Zwiebeln dazugeben und 10 Minuten mitbraten, Tomatenmark und Paprikapulver unterrühren.',
        'Mit Brühe ablöschen und zugedeckt 75 Minuten schmoren lassen.',
        'Paprika würfeln und die letzten 15 Minuten mitgaren, abschmecken.',
        'Bandnudeln nach Packung kochen und dazu servieren.',
      ],
      kidsTip: 'Am Wochenende kochen – am nächsten Tag schmeckt es noch besser.',
    },
    en: {
      title: 'Goulash with noodles',
      ingredients: [
        '800 g beef for stewing',
        '3 onions, diced',
        '2 tbsp tomato puree',
        '2 tbsp sweet paprika',
        '500 ml beef stock',
        '1 pepper',
        '400 g tagliatelle',
        '2 tbsp oil',
      ],
      steps: [
        'Brown the beef well in the oil in batches.',
        'Add the onions and fry for 10 minutes, then stir in the tomato puree and paprika.',
        'Pour in the stock and braise covered for 75 minutes.',
        'Dice the pepper and add it for the last 15 minutes, then season.',
        'Cook the tagliatelle as the packet says and serve with it.',
      ],
      kidsTip: 'Cook it at the weekend – it tastes even better the next day.',
    },
  },
  {
    id: 'meatballs-tomato',
    minutes: 40,
    tags: ['kids'],
    de: {
      title: 'Hackbällchen in Tomatensoße',
      ingredients: [
        '500 g Hackfleisch',
        '1 Ei',
        '3 EL Semmelbrösel',
        '1 Zwiebel, gewürfelt',
        '2 Dosen passierte Tomaten',
        '1 TL Oregano',
        '400 g Spaghetti oder Reis',
        '2 EL Öl',
      ],
      steps: [
        'Hack mit Ei, Bröseln, Salz und Pfeffer verkneten und walnussgroße Bällchen formen.',
        'Bällchen in Öl rundum 5 Minuten anbraten und herausnehmen.',
        'Zwiebel im Bratfett andünsten, Tomaten und Oregano dazugeben.',
        'Bällchen zurück in die Soße legen und 15 Minuten köcheln lassen.',
        'Mit Spaghetti oder Reis servieren.',
      ],
      kidsTip: 'Kinder rollen die Bällchen – je kleiner, desto lieber.',
    },
    en: {
      title: 'Meatballs in tomato sauce',
      ingredients: [
        '500 g mince',
        '1 egg',
        '3 tbsp breadcrumbs',
        '1 onion, diced',
        '2 cans passata',
        '1 tsp oregano',
        '400 g spaghetti or rice',
        '2 tbsp oil',
      ],
      steps: [
        'Knead the mince with the egg, breadcrumbs, salt and pepper and roll walnut-sized balls.',
        'Brown the meatballs all over in the oil for 5 minutes and take them out.',
        'Soften the onion in the pan, then add the passata and oregano.',
        'Put the meatballs back into the sauce and simmer for 15 minutes.',
        'Serve with spaghetti or rice.',
      ],
      kidsTip: 'Kids roll the balls – the smaller, the better.',
    },
  },
];
